import actionTypes from "Search/actionTypes";

export const setSearchQuery = setSearchQuery => dispatch => {
  return dispatch({
    type: actionTypes.SET_SEARCH_QUERY,
    payload: setSearchQuery
  });
};
